// MainContentThemeVars.tsx
import * as React from 'react';
import { GlobalStyles } from '@mui/material';

export default function ThemeGlobals() {
  return (
    <GlobalStyles
      styles={(theme) => ({
        ':root': {
          // Change to theme.palette.background.paper if you prefer
          '--main-content-bg': theme.palette.backgroundLight.primary,
        },

        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: `${theme.palette.scrollbar.thumb} ${theme.palette.scrollbar.background}`,
        },

        '*::-webkit-scrollbar': {
          width: '12px',
          height: '12px',
        },

        '*::-webkit-scrollbar-track': {
          background: theme.palette.scrollbar.background,
          borderRadius: '12px',
        },

        '*::-webkit-scrollbar-thumb': {
          background: theme.palette.scrollbar.thumb,
          borderRadius: '999px',
          border: `2px solid ${theme.palette.scrollbar.background}`,
          minHeight: '40px',
        },

        '*::-webkit-scrollbar-thumb:hover': {
          background: theme.palette.scrollbar.thumb,
        },

        '*::-webkit-scrollbar-corner': {
          background: theme.palette.scrollbar.background,
        },
      })}
    />
  );
}
